<template>
  <div class="process-indicator">
    <div class="progress">
      <div class="mid-line">
        <div class="mid-line-bar" :style="{ width: statusWidth }" />
      </div>
      <div class="indicators">
        <div v-for="step in steps" :class="{ dot: true, active: step.reached }">
          <div class="dot-in" />
          <div :class="{ 'dot-text': true, reached: step.reached }">
            {{ step.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProcessIndicator',
  props: {
    status: Number
  },
  computed: {
    stage() {
      return this.status > 0 ? this.status - 1 : this.status
    },
    statusWidth() {
      // 计算宽度进度，初始进度为1/stage，最多不超过100%
      return Math.min((this.stage * 2 + 1) / 6, 1).toFixed(4) * 100 + '%'
    },
    steps() {
      return [
        { reached: this.status >= 0, title: this.$t('trade.acct-status.open') },
        {
          reached: this.status >= 2,
          title: this.$t('trade.acct-status.approve')
        },
        {
          reached: this.status >= 3,
          title: this.$t('trade.acct-status.deposit')
        },
        {
          reached: this.status >= 4,
          title: this.$t('trade.acct-status.trade')
        }
      ]
    },
    theme() {
      const theme = this.$store.state.settings.theme
      return theme || 'theme-dark'
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.process-indicator {
  display: block;
  width: 100%;
  height: 80px;
  padding: 20px 0;
  overflow: hidden;
  border-bottom: solid 1px var(--special-color);
  .progress {
    position: relative;
    margin: 0 20px 10px;
    height: 13px;
  }
  .mid-line {
    position: absolute;
    z-index: 1;
    top: 6px;
    left: 4px;
    right: 4px;
    height: 1px;
    background-color: fade(@light-grey, 20);
    &-bar {
      height: 1px;
      background-color: var(--active-color);
    }
  }
  .indicators {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 13px;
    .dot {
      position: relative;
      width: 12px;
      height: 12px;
      border-radius: 12px;
      background-color: fade(@light-grey, 20);
      box-sizing: border-box;
      padding: 2px;
      &.active {
        background-color: var(--fade-active-color);
        .dot-in {
          background-color: var(--active-color);
        }
      }
    }
    .dot-in {
      width: 8px;
      height: 8px;
      border-radius: 8px;
      background-color: @light-grey;
    }
    .dot-text {
      position: absolute;
      bottom: -22px;
      left: -8px;
      white-space: nowrap;
      &.reached {
        color: var(--active-color);
      }
    }
  }
  .labels {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: var(--default-font-color);
    .reached {
      color: var(--active-color);
    }
  }
}
</style>
